import { createBloomreachApiUrl } from '../utils/create-api-url.js';
import '@swc/helpers';
import '@bloomreach/spa-sdk';
import { createPath } from '../utils/create-path.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import { brHttpClient } from '../utils/http-client.js';

const createConfiguration = ({ apiUrl , path , options  })=>{
    const { headers ={} , connection , visitor , locale , isMultilingual  } = options;
    if (!apiUrl) {
        throw new Error(`Invalid Bloomreach API Url to fetch a page. Received apiUrl: ${apiUrl}`);
    }
    if (!path) {
        throw new Error(`Invalid path to fetch a page. Received path: ${path}`);
    }
    if (isMultilingual && !locale) {
        throw new Error(`Invalid locale when isMultilingual flag is set to true. Received locale: ${locale}`);
    }
    const currentLocale = isMultilingual ? locale : undefined;
    const cmsBaseUrl = createBloomreachApiUrl(apiUrl, currentLocale);
    const parsedPath = createPath(path, currentLocale);
    const request = {};
    if (connection) {
        request.connection = connection;
    }
    if (headers['x-forwarded-for']) {
        request.headers = {
            'x-forwarded-for': headers['x-forwarded-for']
        };
    }
    const { origin  } = new URL(apiUrl);
    const configuration = {
        endpoint: `${cmsBaseUrl}/resourceapi`,
        path: parsedPath,
        visitor,
        request,
        // reason: there is a slight typing mismatch for the expected header values between Request and HttpClient
        httpClient: brHttpClient,
        origin: origin.replace('www', 'cms'),
        apiVersion: '1.0'
    };
    if (process.env.NODE_ENV !== 'production') {
        console.log(`Fetching: ${configuration.endpoint}
      path: ${configuration.path}
      apiVersion: ${configuration.apiVersion}`);
    }
    return configuration;
};

export { createConfiguration };
//# sourceMappingURL=configuration.js.map
